<template>
  <div class="col-sm-12">
    <div class="card news">
      <div class="channelsHeader">
        <div class="align-items-center justify-content-between news-header">
          <h1 class="card-title news-title">{{ titulo }}</h1>
          <div class="fechaTitle">{{ parseFecha(fecha) }}</div>
        </div>
      </div>
      <!-- end div class="card-header"-->
      <div :class="classBody">
        <div class="vsliderWarp">
          <slider-channels :items="items" :currents="currents" :fi="fi" @addChannel="addChannel" @loadMore="loadMore"
            :lek="LastEvaluatedKey"></slider-channels>
        </div>
      </div>
      <!-- end row justify-content-center-->
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import sliderChannels from "@/components/sliderChannels";

export default {
  name: "canales",
  props: ["fi", "titulo", "fecha", "currents", "idGrupo", "idRegion","actFav"],
  components: { sliderChannels },
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      providerID: this.$store.state.userInfo.net,
      LastEvaluatedKey: null,
      finishFirst: false,
      items: [],
      limit: 110,
      classBody: ["row", "justify-content-center", "Cinner"],
      intevarlo: null,
      llamada: true,


    };
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    }
  },
  mounted() {//
    this.intevarlo = setInterval(this.reload, 1800000); //cada 30 min
  },
  beforeDestroy() {
    clearInterval(this.intevarlo);
  },
  watch: {
    fecha() {
      if (this.fi == "T" || this.fi == "R") {
        console.info("llamada watch fecha");
        this.clear();
        this.getConfig();
      }
    }
  },
  created() {
    this.getConfig();
  },
  methods: {
      parseFecha(fecha) {
      //2020-02-15
      var f_arr = fecha.split("-");
      var new_f =
        f_arr.length == 3 ? f_arr[2] + "/" + f_arr[1] + "/" + f_arr[0] : "";
      return new_f;
    },

    getConfig() {
      console.info("llamada getConfig");
      var post_data = {};
      if(this.actFav){
        post_data = {
            medio: this.fi,
            limit: this.limit,
            fecha: this.fecha,
            token: this.token
          };
        this.getItemsFav(post_data);
        return 0
      }
      switch (this.fi) {
        case "T":
        case "R":
          post_data = {
            medio: this.fi,
            limit: this.limit,
            fecha: this.fecha
          };
          this.getItems(post_data);
          break;
        case "PD":
          var post_data = {
            token: this.token,
            medio: this.fi,
            limit: this.limit,
            providerID: this.providerID,
            feed: "rss"
          };
          if (this.finishFirst)
            this.getRSS(post_data);
          else
            this.getRSSuser(post_data);
          break;
        case "TW":
          var post_data = {
            providerID: this.providerID,
            token: this.token,
            feed: "twitter",
            limit: this.limit
          };
          if (this.finishFirst)
            this.getSourceFeeds(post_data);
          else
            this.getUserFeeds(post_data);
          break;
        case "FB":
          var post_data = {
            providerID: this.providerID,
            token: this.token,
            feed: "facebook",
            limit: this.limit
          };
          if (this.finishFirst)
            this.getSourceFeeds(post_data);
          else
            this.getUserFeeds(post_data);
          break;
        case "Y":
          var post_data = {
            providerID: this.providerID,
            token: this.token,
            feed: "youtube",
            limit: this.limit
          };
          if (this.finishFirst)
            this.getSourceFeeds(post_data);
          else
            this.getUserFeeds(post_data);
          break;
        case "I":
          var post_data = {
            providerID: this.providerID,
            token: this.token,
            feed: "instagram",
            limit: this.limit
          };
          if (this.finishFirst)
            this.getSourceFeeds(post_data);
          else
            this.getUserFeeds(post_data);
          break;
        case "TK":
          var post_data = {
            providerID: this.providerID,
            token: this.token,
            feed: "tiktok",
            limit: this.limit
          };
          if (this.finishFirst)
            this.getSourceFeeds(post_data);
          else
            this.getUserFeeds(post_data);
          break;
      }
    },
    getFecha() {
      moment.tz.setDefault("America/Mexico_City");
      var tmp = moment();

      var f = moment
        .tz(tmp, "America/Mexico_City")
      // .utc()
      // .local();

      return f.format("YYYY-MM-DD");
    },
    getRSS(post_data) {
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      axios.post(self.url + "getRSSsrc", JSON.stringify(post_data))
        .then(response => {
          self.isLoading = false;
          console.log(response);
          for (var i in response.data.result) {
            response.data.result[i]["imagen"] = response.data.result[i]["img"]
          }
          if (self.items.length == 0) {
            self.items = response.data.result;
            self.total = response.data.total;
          } else {
            self.items = [].concat(self.items, response.data.result);
            self.total = self.total + response.data.total;
          }

          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
        })
        .catch(function (error) {
          self.isLoading = false;
          self.error(error);
        });
    },
    getRSSuser(post_data) {
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      axios.post(self.url + "getUserFeeds", JSON.stringify(post_data))
        .then(response => {
          self.isLoading = false;
          console.log(response);
          for (var i in response.data.result) {
            response.data.result[i]["imagen"] = response.data.result[i]["img"]
          }
          if (self.items.length == 0) {
            self.items = response.data.result;
            self.total = response.data.total;
          } else {
            self.items = [].concat(self.items, response.data.result);
            self.total = self.total + response.data.total;
          }

          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
          if (self.LastEvaluatedKey == null) {
            self.finishFirst = true;
            self.getRSS(post_data);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          console.log(error);
          // self.error(error);
        });
    },
    getUserFeeds(post_data) {
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      //if(key) post_data['LastEvaluatedKey'] = key;

      if(this.idGrupo != 0){
        post_data.idGroup = this.idGrupo;
      }
      if(this.idRegion != 0){
        post_data.idRegion = this.idRegion; 
      }
      axios
        .post( self.url + "getUserFeedsV2", JSON.stringify(post_data))
        .then(response => {
          self.isLoading = false;
          console.log(response);
          for (var i in response.data.result) {
            response.data.result[i]["imagen"] = response.data.result[i][
              "imagen"
            ]
              ? response.data.result[i]["imagen"]
              : self.avatar;
          }
          if (self.items.length == 0) {
            self.items = response.data.result;
            self.total = response.data.total;
          } else {
            self.items = [].concat(self.items, response.data.result);
            self.total = self.total + response.data.total;
          }

          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
          console.log('LastEvaluatedKey');
          console.log(self.LastEvaluatedKey);
          if (self.LastEvaluatedKey == null) {
            console.log('traemos source feeds');
            self.finishFirst = true;
            post_data["LastEvaluatedKey"] = null;
            self.getSourceFeeds(post_data);
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          console.log('error catch');
          console.log(error);
        });
    },
    getSourceFeeds(post_data) {
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      if(this.idGrupo != 0){
        post_data.idGroup = this.idGrupo;
      }
      if(this.idRegion != 0){
        post_data.idRegion = this.idRegion; 
      }
     
      axios
        .post( self.url + "getSourceFeedsV2", JSON.stringify(post_data))
        .then(response => {
          self.isLoading = false;
          console.log(response);
          for (var i in response.data.result) {
            response.data.result[i]["imagen"] = response.data.result[i][
              "imagen"
            ]
              ? response.data.result[i]["imagen"]
              : self.avatar;
          }
          if (self.items.length == 0) {
            self.items = response.data.result;
            self.total = response.data.total;
          } else {
            self.items = [].concat(self.items, response.data.result);
            self.total = self.total + response.data.total;
          }

          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
        })
        .catch(function (error) {
          self.isLoading = false;
          console.log(error);
        });
    },
    getItems(post_data) {
      
      if (this.llamada) {
        this.llamada = false
        var self = this;
        post_data.idGroup = this.idGrupo;
        post_data.idRegion = this.idRegion;
        post_data.actFav = this.actFav;
        if (this.LastEvaluatedKey)
          post_data.LastEvaluatedKey = this.LastEvaluatedKey;
       
          axios
          .post(self.url + "getprogramastest", JSON.stringify(post_data))
          .then(response => {
            this.llamada = true;
            console.log(response);

            var result = response.data.result;

            if (self.items.length > 0) {
              self.items = [].concat(self.items, result);
            } else {
              self.items = result;
            }
            self.total = response.data.total;
            self.LastEvaluatedKey = response.data.LastEvaluatedKey
              ? response.data.LastEvaluatedKey
              : null;
          });
      }

    },
    getItemsFav(post_data) {
      
      if (this.llamada) {
        this.llamada = false
        var self = this;
        post_data.actFav = this.actFav;
        if (this.LastEvaluatedKey)
          post_data.LastEvaluatedKey = this.LastEvaluatedKey;
        axios
          .post(self.url + "getChannelsFavUser", JSON.stringify(post_data))
          .then(response => {
            this.llamada = true;
            console.log(response);

            var result = response.data.result;

            if (self.items.length > 0) {
              self.items = [].concat(self.items, result);
            } else {
              self.items = result;
            }
            self.total = response.data.total;
            self.LastEvaluatedKey = response.data.LastEvaluatedKey
              ? response.data.LastEvaluatedKey
              : null;
          });
      }

    },
    addChannel(obj) {
      this.addFav(obj);
      /*switch (this.fi) {
        case "T":
        case "R":
        case "PD":
          this.addFav(obj);
        break;
        case "FB":
          obj.feed = "facebook";
          this.addFav(obj);
          break;
        case "Y":
          obj.feed = "youtube";
          this.addFav(obj);
          break;
        case "I":
          obj.feed = "instagram";
          this.addFav(obj);
          break;
        case "Y":
          obj.feed = "youtube";
          this.addFav(obj);
          break;
        case "TW":
          obj.feed = "twitter";
          this.addFav(obj);
        break;
        case "PD":
          obj.feed = "rss";
          this.addFavFeed(obj);
        break;
      }*/
    },
    addFav(obj) {
      var post_data = {
        token: this.token,
        medio: this.fi,
        key: obj.key,
        fecha: this.fecha
      };
      var self = this;
      axios
        //.post(this.url + "addNoticierosToUser", JSON.stringify(post_data))
        .post(this.url + "addNewsToDashboard", JSON.stringify(post_data)) //EGM 241211
        .then(response => {
          if (response.data.success) {
            self.$emit("addChannel", obj);
          } else {
            self.$emit("error", response.data.error);
          }
        })
        .catch(function (error) {
          self.error(error);
          console.log(error);
        });
    },
    addFavFeed(obj) {
      var post_data = {
        token: this.token,
        key: obj.key,
        feed: obj.feed
      };

      var self = this;
      axios
        .post(this.url + "addFavFeed", JSON.stringify(post_data))
        .then(response => {
          console.log(response);
          if (response.data.success) {
            self.$emit("addChannel", response.data.data.data);
          } else {
            self.$emit("error", response.data.error);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      this.$emit("reload");
    },
    loadMore() {
      console.log("llamada loadMore");
      if (this.LastEvaluatedKey) this.getConfig();
    },
    clear() {
      this.items = [];
      this.LastEvaluatedKey = null;
      this.total = 0;
    }
  }
};
</script>

<style scoped>
.Cinner {
  padding: 0px 1px;
}

.vsliderWarp {
  width: 100%;
  padding: 0px 1px;
  /**  background-color: #fff;*/
  margin-bottom: 0px;
}

.hidden {
  display: none;
}

.groupNews {
  background: none !important;
  color: #062633 !important;
}

.news-header {
  background-color: transparent;
  border: #062633 1px solid;
  text-align: center;
}

.channelsHeader {
  border-bottom: 1px solid #123746;
  margin-bottom: 5px;
  display: none;
}

@media screen and (max-width: 991px) {
  .channelsHeader {
    display: block;
  }
}

.news-title {
  color: #fff;
  margin-bottom: 0px;
}

.fechaTitle {
  color: #fff;
  margin-bottom: 5px;
}

.news {
  margin-bottom: 10px;
  background: none;
  padding: 0 30px 0 30px;
}

.icon-button {
  background: #062633;
  color: #00b99e;
}

.icon-button:hover {
  background: #00b99e;
  color: white;
}

.active {
  background-color: #00b99e;
  fill: white !important;
  color: white !important;
}

.active:hover {
  background-color: #062633;
  fill: #00b99e !important;
  color: #00b99e !important;
}
</style>
 